import React, { useEffect, useRef, useState } from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../label-custom'
import { Controller, useForm } from 'react-hook-form'
import { Checkbox, DatePicker } from 'antd'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { createWorksAPI } from '../../../services/history-works'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import updateProfilePercent from '../../../helper/updateProfile-percent'
import { useDispatch } from 'react-redux'
import useNumberInput from '../../../helper/input-fix-num'
import moment from 'moment'

export default function CreateWorkHistory({
  param,
  setIsSave,
  showCreate,
  isSave,
  fnGetWorks,
  setShowCreate,
  have,
  setOnStatus,
  onStatus
}) {
  const schema = yup
    .object({
      company: yup.string().required('Please, Fill Company Name'),
      histyPosition: yup.string().required('Please, Fill Position'),
      duty: yup.string().required('Please, Fill Job description'),
      fromYear: yup
        .string()
        .required('Please, Fill Start Date')
        .test(
          'is-toYear-after-adYear',
          'Pleace, re-check Start Year and End Date again',
          function (value) {
            const toYear = this.parent.toYear
            if (!toYear) return true // Skip validation if toYear is not set
            return parseInt(value) <= parseInt(toYear)
          }
        ),
      toYear: yup.string().required('Please, Fill End Year'),
      histyReason: yup.string().required('Please, Fill Reason for leaving')
    })
    .required()
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [noWork, setNoWork] = useState(false)
  const [isHave, setIsHave] = useState(true)
  const [disableYearStart, setDisableYearStart] = useState(null)
  const [disableYearEnd, setDisableYearEnd] = useState(null)
  const [disableYear, setDisableYear] = useState(null)
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)
  const dispatch = useDispatch()

  // useEffect(() => {
  //   currentYear()
  // }, [showCreate])

  // const currentYear = () => {
  //   const d = new Date()
  //   let year = d.getFullYear()
  //   setDisableYearStart(year)
  // }
  useEffect(() => {
    setValue('fromYear', `25`)
    setValue('toYear', `25`)
  }, [setValue, showCreate])

  const handleNoWork = () => {
    setNoWork(!noWork)
    if (noWork) {
      setIsHave(true)
    } else {
      setIsHave(false)
    }
  }
  const onSubmit = async (data) => {
    setIsSave(true)
    if (isHave) {
      const body = { ...param, ...data, isHave }
      createWorks(body)
    } else {
      const body = {
        ...param,
        isHave,
        company: '',
        histyPosition: '',
        fromYear: '',
        duty: '',
        // period,
        toYear: '',
        histyReason: ''
      }
      createWorks(body)
    }
  }

  const createWorks = async (body) => {
    try {
      const data = await createWorksAPI(body)

      if (data?.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          handleClose()
          fnGetWorks()
          fnReset()
          updateProfilePercent(dispatch)
        })
      } else {
        Error_false(data)
      }
      setIsSave(false)
      setOnStatus(!onStatus)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }
  const fnReset = () => {
    setError('company', false)
    setError('histyPosition', false)
    setError('duty', false)
    setError('fromYear', false)
    setError('toYear', false)
    setError('histyReason', false)
  }
  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }
  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Work History</label>
        {noWork ? (
          <Col md={12}>
            <LabelCustom text={'Company Name'} />
            <Form.Control disabled={noWork} maxLength={50} />
          </Col>
        ) : (
          <Col md={12}>
            <LabelCustom text={'Company Name'} />
            <Controller
              name={'company'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={noWork}
                  maxLength={50}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.company?.message && (
              <label className="small text-danger">
                {errors.company.message}
              </label>
            )}
          </Col>
        )}

        {noWork ? (
          <Col md={12}>
            <LabelCustom text={'Position'} />
            <Form.Control disabled={noWork} maxLength={50} />
          </Col>
        ) : (
          <Col md={12}>
            <LabelCustom text={'Position'} />
            <Controller
              name={'histyPosition'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={noWork}
                  maxLength={50}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.histyPosition?.message && (
              <label className="small text-danger">
                {errors.histyPosition.message}
              </label>
            )}
          </Col>
        )}

        {noWork ? (
          <Col md={12}>
            <LabelCustom text={'Job Description'} />
            <Form.Control disabled={noWork} maxLength={50} />
          </Col>
        ) : (
          <Col md={12}>
            <LabelCustom text={'Job Description'} />
            <Controller
              name={'duty'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={noWork}
                  maxLength={50}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.histyPosition?.message && (
              <label className="small text-danger">
                {errors.histyPosition.message}
              </label>
            )}
          </Col>
        )}

        {noWork ? (
          <Col md={6}>
            <LabelCustom text={'From (พ.ศ.)'} />
            <Form.Control disabled={noWork} maxLength={50} />
          </Col>
        ) : (
          <Col xl={6}>
            <LabelCustom text="From (พ.ศ.)" />

            <Controller
              name={'fromYear'}
              control={control}
              render={({ field: { value = '' } }) => (
                <Form.Control
                  value={value}
                  disabled={noWork}
                  maxLength={4}
                  onKeyDown={handleKeyDownNum}
                  onChange={(e) => {
                    setValue('fromYear', e.target.value)
                    setError('fromYear', false)
                  }}
                />
                // <DatePicker
                //   // value={value}
                //   disabled={noWork}
                //   className="form-control"
                //   onChange={(date, dateString) => {
                //     setValue('fromYear', dateString)
                //     setError('fromYear', date)
                //     setDisableYear(dateString)
                //   }}
                //   picker="year"
                //   disabledDate={(current) =>
                //     current && disableYearEnd && disableYearStart >= disableYearEnd
                //       ? current.year() > parseInt(disableYearEnd)
                //       : disableYearStart &&
                //         current.year() > parseInt(disableYearStart)
                //   }
                // />
              )}
            />
            {errors.fromYear?.message && (
              <label className="small text-danger">
                {errors.fromYear.message}
              </label>
            )}
          </Col>
        )}
        {noWork ? (
          <Col md={6}>
            <LabelCustom text={'To (พ.ศ.)'} />
            <Form.Control disabled={noWork} maxLength={50} />
          </Col>
        ) : (
          <Col xl={6}>
            <LabelCustom text="To  (พ.ศ.)" />
            <Controller
              name={'toYear'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <Form.Control
                  value={value}
                  disabled={noWork}
                  maxLength={4}
                  onKeyDown={handleKeyDownNum}
                  onChange={(e) => {
                    setValue('toYear', e.target.value)
                    setError('toYear', false)
                  }}
                />
                //     <DatePicker
                //       disabled={noWork}
                //       className="form-control"
                //       onChange={(date, dateString) => {
                //         setValue('toYear', dateString)
                //         setError('toYear', dateString)
                //         setDisableYearEnd(dateString)
                //       }}
                //       disabledDate={(current) =>
                //         current &&
                //         disableYear &&
                //         current.year() < parseInt(disableYear)
                //       }
                //       picker="year"
                //     />
              )}
            />
            {errors.toYear?.message && (
              <label className="small text-danger">
                {errors.toYear.message}
              </label>
            )}
          </Col>
        )}

        {noWork ? (
          <Col md={12}>
            <LabelCustom text={'Reason for leaving'} />
            <Form.Control
              disabled={noWork}
              maxLength={50}
              as="textarea"
              rows={3}
            />
          </Col>
        ) : (
          <Col xl={12}>
            <LabelCustom text="Reason for leaving" />
            <Controller
              name={'histyReason'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  maxLength={50}
                  as="textarea"
                  disabled={noWork}
                  rows={3}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.histyReason?.message && (
              <label className="small text-danger">
                {errors.histyReason.message}
              </label>
            )}
          </Col>
        )}

        {have?.status_id === 0 || have?.status_id === 1 ? (
          <></>
        ) : (
          <Col xl={12}>
            <div>
              <Checkbox onClick={handleNoWork} /> No work experience
            </div>
          </Col>
        )}
        <Col xl={12} className="text-center">
          <Button
            className="px-4 text-primary me-2"
            variant="light"
            type="button"
            disabled={isSave}
            onClick={handleClose}
          >
            Close
          </Button>
          {noWork ? (
            <Button className="px-4 " disabled={isSave} onClick={onSubmit}>
              {isSave ? 'Saving...' : 'Save'}
            </Button>
          ) : (
            <Button className="px-4 " disabled={isSave} type="submit">
              {isSave ? 'Saving...' : 'Save'}
            </Button>
          )}
        </Col>
      </Form>
    </ModalCustom>
  )
}
